import React, { useState } from 'react';
import './errorMessage.scss';
import { useAppDispatch } from 'store/app/hooks';
import { showValidationErrorsSnackbar } from '../snackbar/Snackbar.slice';

interface ErrorProps {
    error?: any
}

const ErrorMessage = ({ error }: ErrorProps) => {
    const dispatch = useAppDispatch();
    const [displayErrors, setDisplayErrors] = useState(false);
    
    if(error.isApiException){
        error = JSON.parse(error.response);
    }
    if(error.errors){
        error = error.errors;
    }
    
    const arrayErrors: string[] = Object.keys(error).reduce((errs: string[], key) => {
        const messages = Array.isArray(error[key])
        ? error[key]
        : error[key]?.value?.errors?.map((e: { errorMessage: string }) => e.errorMessage) || [];
        if (Array.isArray(messages)) {
            errs.push(...messages);
        } else if (messages) {
            errs.push(messages);
        }
        return errs;
    }, []);

    const handleShowErrors = () => {
        setDisplayErrors(true);
        showValidationErrorsSnackbar(dispatch, arrayErrors);
    };
    
    if (arrayErrors.length === 0) {
        return null;
    } else if (arrayErrors.length === 1) {
        return <div className="error">{arrayErrors[0]}</div>;
    } else {
        return (
            <div className="error">
            There were multiple validation errors.{' '}
            <span className="link-text" onClick={handleShowErrors}>
                Click here to view them.
            </span>
        </div>
        );
    }
}

export default React.memo(ErrorMessage);